import React, { useCallback, useEffect, useState } from "react";
import ButtonView from "../common/button/ButtonView";
import { useDispatch } from "react-redux";
import "./styles/DeleteView.css";
import {
  CANCEL_LABEL,
  DELETE_LABEL,
  VEHICLE,
  MARGIN_15,
} from "../../utils/GlobalConstants";
import {
  addItemInSelectedPart,
  addItemInPartListUpdate,
  addItemInSelectedVehicle,
  addItemInVehicleListUpdate,
} from "../../store/SurveyPageData";
import {
  deleteSingleOrMultiplePart,
  deleteSingleOrMultipleVehicle,
} from "../../services/SurveyRequest";
import { useTranslation } from "react-i18next";

const DeleteView = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [onDefault, setOnDefault] = useState(false);

  const handleDeleteButtonAction = useCallback(async () => {
    props.setIsLoading(true);
    if (props.source === VEHICLE) {
      try {
        let payload = {
          surveyId: props?.selectedSurveyId,
          vehicleIds: props.selected,
        };
        const res = await deleteSingleOrMultipleVehicle(payload);
        dispatch(addItemInVehicleListUpdate(res.data[0].id));
        dispatch(addItemInPartListUpdate({}));
        dispatch(addItemInSelectedVehicle({}));
      } catch (e) {
        props.handleClosedel();
        props.setIsLoading(false);
      }
    } else {
      try {
        let payload = {
          surveyId: props?.selectedSurveyId,
          partIds: props.selected,
        };
        const res = await deleteSingleOrMultiplePart(payload);
        dispatch(addItemInPartListUpdate(res?.data[0]?.id));
        dispatch(addItemInSelectedPart({}));
      } catch (e) {
        props.handleClosedel();
        props.setIsLoading(false);
      }
    }
    props.handleClosedel();
    props.setSelected([]);
    props.setIsLoading(false);
  },[dispatch,props]);
 
  const handleUserKeyPress = useCallback(
    (event) => {
      if (event.key === "Enter" && props.source !== VEHICLE) {
        handleDeleteButtonAction();
      }
    },
    [props.source, handleDeleteButtonAction]
  );

  useEffect(() => {
    if (props.source !== VEHICLE) {
      setOnDefault(true);
    } else {
      setOnDefault(false);
    }
  }, [props]);

  useEffect(() => {
    window.addEventListener("keydown", handleUserKeyPress);
    return () => {
      window.removeEventListener("keydown", handleUserKeyPress);
    };
  }, [handleUserKeyPress, props.source]);

  return (
    <div>
      <div className="delMsg">
        {props.source === VEHICLE
          ? t("tab1.messages.vehicle_del")
          : t("tab1.messages.del_part")}
      </div>
      <div className="btnContainer">
        <ButtonView
          testid={DELETE_LABEL}
          label={DELETE_LABEL}
          style={MARGIN_15}
          onClick={handleDeleteButtonAction}
          className={onDefault && "btn-default-style"}
        />

        <ButtonView
          testid={CANCEL_LABEL}
          label={CANCEL_LABEL}
          onClick={() => {
            props.handleClosedel();
          }}
        />
      </div>
    </div>
  );
};
export default DeleteView;
